import BasicRepository from "./basicRepository";
import Client from "../client";
import {AccountResource} from "../resources";
import {AzureWebSite} from "client/resources/azureWebSite";

class AccountRepository extends BasicRepository<AccountResource> {
    constructor(client: Client) {
        super("Accounts", client);
    }
    getWebSites(account: AccountResource): Promise<AzureWebSite[]> {
        return this.client.get(account.Links["WebSites"]);
    }
    getCloudServices(account: AccountResource) {
        return this.client.get(account.Links["CloudServices"]);
    }
    getStorageAccounts(account: AccountResource) {
        return this.client.get(account.Links["StorageAccounts"]);
    }
    getResourceGroups(account: AccountResource) {
        return this.client.get(account.Links["ResourceGroups"]);
    }
    getFabricApplications(account: AccountResource) {
        return this.client.get(account.Links["FabricApplications"]);
    }
}

export default AccountRepository;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/repositories/accountRepository.ts